export default __webpack_public_path__ + "static/media/PAS RESPECTÉ.89451583.svg";